import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/contexts/AuthProvider";
import { ArrowRight } from "lucide-react";

export function ArtistRecruitmentBanner() {
  const { t } = useTranslation();
  const { user } = useAuth();

  // Only show for logged-out users
  if (user) {
    return null;
  }

  return (
    <div className="bg-black text-white py-2.5 text-center text-sm">
      <div className="container flex items-center justify-center gap-1.5 flex-wrap">
        <span>{t("artistRecruitment.question")}</span>
        <span className="hidden sm:inline">{t("artistRecruitment.cta")}</span>
        <Link 
          to="/for-artists" 
          className="inline-flex items-center gap-1 font-medium underline underline-offset-2 hover:no-underline"
        >
          {t("artistRecruitment.readMore")}
          <ArrowRight className="h-3.5 w-3.5" />
        </Link>
      </div>
    </div>
  );
}
